import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: theme.spacing(1.875),
  },

  subheader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 1.875),
  },

  timerNote: {
    marginTop: theme.spacing(1.875),
  },

  shareLink: {
    marginTop: theme.spacing(1.875),
  },

  adminTitleContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: theme.spacing(1.875),
  },

  hatIcon: {
    width: theme.spacing(1.875),
    height: theme.spacing(1.875),
    fontWeight: 700,
    letterSpacing: '0.028px',
    marginLeft: theme.spacing(0.625),
    marginBottom: theme.spacing(1.875),
  },

  iconsContainer: {
    display: 'flex',
    marginLeft: 'auto',
    justifyContent: 'flex-end',
  },
}));
